class AppDownloadQR extends HTMLElement {
    constructor() {
        super();
        this.qrInstance = null;
        this.mediaQuery = null;
    }

    connectedCallback() {
        const container = this.querySelector('[data-qr-container]');
        if (!container) return;

        const qrUrl = this.dataset.qrUrl || '';
        const enableDynamic = this.dataset.dynamicQr === 'true';

        if (!qrUrl || !enableDynamic || typeof window.QRCode === 'undefined') {
            return;
        }

        // Setup responsive behavior
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.mediaQuery.addEventListener('change', this.handleViewportChange);

        // Initial generation
        this.generateQR(container, qrUrl);
    }

    generateQR(container, url) {
        try {
            container.innerHTML = '';

            // Hide any remaining static images
            const existingImages = container.parentElement?.querySelectorAll('img[data-static-qr]');
            existingImages?.forEach(img => img.style.display = 'none');

            // Get colors from the section element
            const section = this.closest('section') || this.closest('.app-download');
            const styles = section ? getComputedStyle(section) : getComputedStyle(document.documentElement);
            const colorDark = styles.getPropertyValue('--color-foreground').trim() || '#862633';
            const colorLight = '#ffffff';

            this.qrInstance = new window.QRCode(container, {
                text: url,
                width: 175,
                height: 175,
                colorDark,
                colorLight,
                correctLevel: window.QRCode.CorrectLevel.H,
                useSVG: true
            });

            container.setAttribute('role', 'img');
            container.setAttribute('aria-label', 'QR Code to download the app');

            // Style QR code immediately after generation
            this.styleQRCode(container);
        } catch (error) {
            console.error('QR code generation failed:', error);
        }
    }

    styleQRCode(container) {
        const svg = container.querySelector('svg');
        if (!svg) return;

        // Add rounded corners to QR code dots
        const rects = svg.querySelectorAll('rect');
        rects.forEach(rect => {
            const width = parseFloat(rect.getAttribute('width'));
            const height = parseFloat(rect.getAttribute('height'));
            const radius = Math.min(width, height) * 0.4;
            rect.setAttribute('rx', radius.toString());
            rect.setAttribute('ry', radius.toString());
        });

        // Get SVG dimensions from viewBox
        const viewBox = svg.getAttribute('viewBox');
        let svgWidth, svgHeight;

        if (viewBox) {
            const [, , width, height] = viewBox.split(' ').map(Number);
            svgWidth = width;
            svgHeight = height;
        } else {
            svgWidth = svg.clientWidth || 175;
            svgHeight = svg.clientHeight || 175;
        }

        const centerX = svgWidth / 2;
        const centerY = svgHeight / 2;

        // Create small white circular background
        const circleRadius = 10;
        const logoBg = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        logoBg.setAttribute('cx', centerX);
        logoBg.setAttribute('cy', centerY);
        logoBg.setAttribute('r', circleRadius);
        logoBg.setAttribute('fill', '#ffffff');
        svg.appendChild(logoBg);

        // Add "BD" logo text
        const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', centerX);
        text.setAttribute('y', centerY + 4);
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('fill', '#862633');
        text.setAttribute('font-size', '13');
        text.setAttribute('font-weight', '500');
        text.setAttribute('font-family', 'Brush Script MT, Lucida Handwriting, cursive');
        text.setAttribute('font-style', 'italic');
        text.setAttribute('letter-spacing', '0.3');
        text.textContent = 'BD';
        svg.appendChild(text);
    }

    handleViewportChange(e) {
        const container = this.querySelector('[data-qr-container]');
        if (!container) return;

        const qrUrl = this.dataset.qrUrl || '';

        if (e.matches && !this.qrInstance) {
            this.generateQR(container, qrUrl);
        } else if (!e.matches && this.qrInstance) {
            container.innerHTML = '';
            this.qrInstance = null;
        }
    }

    disconnectedCallback() {
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        }
    }
}

if (!customElements.get('app-download-qr')) {
    customElements.define('app-download-qr', AppDownloadQR);
}

